import { render, staticRenderFns } from "./NotificationInvoiceUnlock.vue?vue&type=template&id=5581c8e6&scoped=true&"
import script from "./NotificationInvoiceUnlock.vue?vue&type=script&lang=js&"
export * from "./NotificationInvoiceUnlock.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInvoiceUnlock.vue?vue&type=style&index=0&id=5581c8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5581c8e6",
  null
  
)

export default component.exports